import { TeamNameDisplayMode } from "../state/useTeamNameDisplayStore";

/**
 * Canonical key for matching a wilaya name across data sources.
 * `teams.wilaya` is mixed-case/accented with variants ("Aïn Defla", "Béjaïa"),
 * while `locations.wilaya` is UPPERCASE/unaccented ("AIN DEFLA", "BEJAIA").
 * Normalizing both (deaccent + uppercase + trim) makes them join cleanly.
 */
export function normalizeWilayaKey(wilaya: string | null | undefined): string {
  return (wilaya ?? "")
    .normalize("NFD")
    .replace(new RegExp("[\\u0300-\\u036f]", "g"), "")
    .trim()
    .toUpperCase();
}

/**
 * Locale-aware wilaya label: Arabic name (from a normalized wilaya→wilaya_ar map
 * derived from `locations`) when mode='arabic' and a match exists, else the raw
 * Latin wilaya. Returns null for an empty/missing wilaya.
 */
export function getLocalizedWilaya(
  wilaya: string | null | undefined,
  mode: TeamNameDisplayMode,
  arMap: Map<string, string>
): string | null {
  const raw = (wilaya ?? "").trim();
  if (!raw) return null;
  if (mode === "arabic") {
    const ar = arMap.get(normalizeWilayaKey(raw));
    if (ar) return ar;
  }
  return raw;
}
